import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchRegistrationConfig } from "../../api/services/registration";
import { getMpinDigitsFromAuth } from "../../utils/registrationConfig";

export const loadRegistrationConfig = createAsyncThunk(
  "appConfig/loadRegistrationConfig",
  async (_, { rejectWithValue }) => {
    try {
      const result = await fetchRegistrationConfig();
      if (!result?.success) {
        return rejectWithValue(result?.error || "Invalid registration config response");
      }
      return result.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.message ||
          "Failed to load registration configuration"
      );
    }
  }
);

const appConfigSlice = createSlice({
  name: "appConfig",
  initialState: {
    registration: null,
    registrationLoading: false,
    registrationError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadRegistrationConfig.pending, (state) => {
        state.registrationLoading = true;
        state.registrationError = null;
      })
      .addCase(loadRegistrationConfig.fulfilled, (state, action) => {
        state.registrationLoading = false;
        state.registration = action.payload;
      })
      .addCase(loadRegistrationConfig.rejected, (state, action) => {
        state.registrationLoading = false;
        state.registrationError = action.payload || "Failed to load registration config";
      });
  },
});

export const selectRegistrationConfig = (state) => state.appConfig.registration;
export const selectRegistrationFields = (state) =>
  state.appConfig.registration?.fields ?? {};
export const selectRegistrationAuth = (state) =>
  state.appConfig.registration?.auth ?? {};
export const selectRegistrationDefaults = (state) =>
  state.appConfig.registration?.defaults ?? {};
export const selectMpinDigits = (state) =>
  getMpinDigitsFromAuth(state.appConfig.registration?.auth);
export const selectMpinEnabled = (state) =>
  state.appConfig.registration?.auth?.mpin_enabled !== false;

export default appConfigSlice.reducer;
